import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import Tooltip from "react-tooltip";

interface VendorInvoiceDetailsProps {
  rowData: any;
}

export const SubmittedView: React.FC<VendorInvoiceDetailsProps> = ({
  rowData,
}) => {
  const [debitAdjustment, setDebitAdjustment] = useState<any>([]);
  useEffect(() => {
    const debitAdj = Array.from(
      new Set(rowData.debitAdjBillRef?.map((x) => x))
    );
    setDebitAdjustment(debitAdj);
  }, []);
  return (
    <>
      <div className="grid md:grid-cols-1 lg:grid-cols-3">
        {/* Left fields */}
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Service No. Account:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.accountNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Corporate Office Number:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.storeNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Office Status:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeStatus}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Confie Office Name:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeName}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Office Address:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeStreet} {", "} {rowData?.officeCity} {", "}
              {rowData?.officeStateCode} {rowData?.officeZipcode}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Confie Brand:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeBrand}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Amount Paid:
            </label>
            <div className="flex flex-row">
              <label className="expandedDataVIP fontExpand">
                {rowData?.amountPaid}
              </label>
              {rowData?.billAdjustment?.length > 0 ? (
                <div className="ml-4">
                  <Tooltip
                    id="voided"
                    place="top"
                    effect="solid"
                    type="info"
                    border={false}
                    arrowColor="#6b7280"
                    backgroundColor="#6b7280"
                    textColor="white"
                  />
                  <InformationCircleIcon
                    data-tip={
                      "Check Debit Adjustment for new Total Amount Paid."
                    }
                    data-for="voided"
                    className="text-white bg-pink-900 rounded-full h-4 w-4"
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Billing Period Start Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.servicePeriodDate
                ? rowData?.servicePeriodDate &&
                  new Date(rowData?.servicePeriodDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Billing Period End Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.billingPeriodEndDate
                ? rowData?.billingPeriodEndDate &&
                  new Date(rowData?.billingPeriodEndDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Expense Account:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.expenseAccountDescription}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Auto Pay:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.autoPayName}
            </div>
          </div>
        </div>
        {/* end of 1st col */}
        {/* start of 2nd col */}
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Invoice No.:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.invoiceNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Date Capture:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.dateCapture
                ? rowData?.dateCapture &&
                  new Date(rowData?.dateCapture).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Vendor Name:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.vendorName}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Vendor ID:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.vendorCode}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bill Reference:
            </label>
            <div className="flex flex-col">
              <div
                className="col-span-2 expandedDataVIP fontExpand blueAndBold underline cursor-pointer"
                onClick={() => {
                  window.open(
                    `https://acumaticastg.confie.com/Main?CompanyID=Admin+Retail&ScreenId=AP301000&DocType=INV&RefNbr=${rowData?.billRefNumber}`,
                    "_blank"
                  );
                }}
              >
                {rowData?.billRefNumber}
              </div>
              <div>
                {debitAdjustment?.length > 0
                  ? debitAdjustment.map((bill, index) => (
                      <div className="col-span-2 expandedDataVIP fontExpand blueAndBold">
                        <label
                          key={index}
                          className="underline cursor-pointer"
                          onClick={() => {
                            window.open(
                              `https://acumaticastg.confie.com/Main?CompanyID=Admin+Retail&ScreenId=AP301000&DocType=ADR&RefNbr=${bill}`,
                              "_blank"
                            );
                          }}
                        >
                          {bill}
                        </label>
                        <label className="text-pink-700 italic">
                          {" "}
                          - Debit Adjusment
                        </label>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Payment Reference No.:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.paymentReference}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bank Reference:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.bankReference}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bank Reference Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.bankReferenceDate
                ? rowData?.bankReferenceDate &&
                  new Date(rowData?.bankReferenceDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bank Account:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.bankAccount
                ? rowData?.bankAccount.replace(/.(?=.{4})/g, "x")
                : null}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Utility Type:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.utilityType}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Description:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.description}
            </div>
          </div>
        </div>
        {/* end of 2nd col */}
        {/* start of 3rd col */}
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Branch GL:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.branchGL}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Subaccounts:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.glsubaccounts}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Due Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.duedate
                ? rowData?.duedate &&
                  new Date(rowData?.duedate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Previous Balance Amount:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData.previousBalanceAmount}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Draft Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.draftDate
                ? rowData?.draftDate &&
                  new Date(rowData?.draftDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Invoice Image:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.invoiceImageAttachment}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Note:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.noteSection}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Created By:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.createdBy}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Created Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.createdDate
                ? rowData?.createdDate &&
                  new Date(rowData?.createdDate).toLocaleDateString() +
                    " " +
                    new Date(rowData?.createdDate).toLocaleTimeString(
                      navigator.language,
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )
                : ""}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
